import type { HTMLAttributes } from 'react'
import { imageAssets } from '@/assets/images'

const sizeClasses = {
  md: 'text-title-xxl',
  lg: 'text-title-xxxl',
}

const variantSources = {
  dark: imageAssets.logo.hero,
  light: imageAssets.logo.footer,
}

type LogoMarkProps = HTMLAttributes<HTMLDivElement> & {
  size?: keyof typeof sizeClasses
  variant?: keyof typeof variantSources
}

function LogoMark({ size = 'md', variant = 'dark', className, ...props }: LogoMarkProps) {
  const classes = [
    'block',
    sizeClasses[size],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} {...props}>
      <img
        src={variantSources[variant]}
        alt="NXT HUMANS"
        className="h-full w-full object-contain"
      />
    </div>
  )
}

export default LogoMark
